var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroomStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32613 19.7952C4.91192 20.381 5.8335 20.4091 6.38453 19.8581L7.87549 18.3672L19.854 6.38859C20.4051 5.83756 20.3769 4.91598 19.7911 4.33019C19.2053 3.7444 18.2838 3.71624 17.7327 4.26727L5.75049 16.2495L4.26321 17.7368C3.71218 18.2878 3.74035 19.2094 4.32613 19.7952Z",
    stroke: "#191C1E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroomStick);
export default __webpack_public_path__ + "static/media/broomStick.509884aacca6c586c12ba86a39812712.svg";
export { ForwardRef as ReactComponent };